module.exports = __webpack_public_path__ + "img/worldcup.02ce5fce.png";